import { IProject } from "../@types";
import { expenseService, invoiceService, paymentService } from "../services";
import { projectService } from "../services/projectService";
import { handleError, withRetry } from "../utils";

export const getProject = async (id: string) => {
  return withRetry(async () => {
    const res = await projectService.get(`/projects/${id}`);
    return res.data;
  }).catch(handleError);
};

export const removeProjectFromInvoice = async (
  invoiceId: string,
  id: string,
  hasProject: boolean,
) => {
  return withRetry(async () => {
    const res = await invoiceService.patch(
      `/invoices/${invoiceId}/projects/toggle`,
      {
        hasProject: hasProject,
        projectId: id,
      },
    );
    return res.data;
  }).catch(handleError);
};
export const removeProjectFromExpense = async (
  expenseId: string,
  id: string,
  hasProject: boolean,
) => {
  return withRetry(async () => {
    const res = await paymentService.patch(
      `/expenses/${expenseId}/projects/toggle`,
      {
        hasProject: hasProject,
        projectId: id,
      },
    );
    return res.data;
  }).catch(handleError);
};
export const createProject = async (projectData: Partial<IProject>) => {
  return withRetry(async () => {
    const res = await projectService.post("/projects", projectData);
    return res.data;
  }).catch(handleError);
};
